import { Dispatch, AnyAction } from 'redux';
import { ThunkAction, ThunkDispatch } from 'redux-thunk';
import {
  UPDATE_PROFILE_REQUEST,
  UPDATE_PROFILE_SUCCESS,
  UPDATE_PROFILE_FAILURE,
  VERIFY_EMAIL_REQUEST,
  VERIFY_EMAIL_SUCCESS,
  VERIFY_EMAIL_FAILURE,
  RESEND_VERIFICATION_REQUEST,
  RESEND_VERIFICATION_SUCCESS,
  RESEND_VERIFICATION_FAILURE
} from '../../../constants/profile/profile';
import { message } from 'antd';
import { RootState } from '../../store/store';
import fetchWithIP from '../utils/FechHeaders';


export interface ProfileDto {
  nombre?: string;
  apellidos?: string;
  contrasena?: string;
  contrasena_actual?: string;
  email?: string;
  pais?: string;
  telefono?: string;
  timezone?: string;
  imagen_perfil?: File | null;
}

export interface VerifyEmailDto {
  codigo_verificacion: string;
}


export const updateProfileRequest = () => ({
  type: UPDATE_PROFILE_REQUEST
});

export const updateProfileSuccess = (data: any) => ({
  type: UPDATE_PROFILE_SUCCESS,
  payload: data
});

export const updateProfileFailure = (error: string) => ({
  type: UPDATE_PROFILE_FAILURE,
  payload: error
});

export const verifyEmailRequest = () => ({
  type: VERIFY_EMAIL_REQUEST
});

export const verifyEmailSuccess = (data: any) => ({
  type: VERIFY_EMAIL_SUCCESS,
  payload: data
});

export const verifyEmailFailure = (error: string) => ({
  type: VERIFY_EMAIL_FAILURE,
  payload: error
});

export const resendVerificationRequest = () => ({
  type: RESEND_VERIFICATION_REQUEST
});

export const resendVerificationSuccess = (data: any) => ({
  type: RESEND_VERIFICATION_SUCCESS,
  payload: data
});

export const resendVerificationFailure = (error: string) => ({
  type: RESEND_VERIFICATION_FAILURE,
  payload: error
});

export const updateProfile = (
  profileData: ProfileDto
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(updateProfileRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }
      const formData = new FormData();
      
      Object.entries(profileData).forEach(([key, value]) => {
        if (value !== undefined && value !== null) {
          if (key === 'imagen_perfil' && value instanceof File) {
            formData.append('imagen_perfil', value);
          } else if (key !== 'imagen_perfil') {
            formData.append(key, String(value));
          }
        }
      });

      console.log('Enviando datos al backend:', Object.fromEntries(formData.entries()));

      const response = await fetchWithIP(`profile`, {
        method: 'PUT'},
        formData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al actualizar el perfil');
      }

      dispatch(updateProfileSuccess(data));
      message.success('Perfil actualizado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al actualizar el perfil';
      dispatch(updateProfileFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };

  
};

export const verifyEmail = (
  verifyData: VerifyEmailDto
): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(verifyEmailRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(`profile/verify-email`, {
        method: 'POST'},
        verifyData
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al verificar el correo electrónico');
      }

      dispatch(verifyEmailSuccess(data));
      message.success('Correo electrónico verificado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al verificar el correo electrónico';
      dispatch(verifyEmailFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};

export const resendVerificationCode = (): ThunkAction<Promise<any>, RootState, unknown, AnyAction> => {
  return async (dispatch: ThunkDispatch<RootState, unknown, AnyAction>) => {
    dispatch(resendVerificationRequest());

    try {
      const token = localStorage.getItem('token');

      if (!token) {
        throw new Error('No se encontró token de autenticación');
      }

      const response = await fetchWithIP(`profile/resend-verification`, {
        method: 'POST'
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Error al reenviar el código de verificación');
      }

      dispatch(resendVerificationSuccess(data));
      message.success('Código de verificación reenviado exitosamente');
      return data;
    } catch (error: any) {
      const errorMsg = error.message || 'Error desconocido al reenviar el código de verificación';
      dispatch(resendVerificationFailure(errorMsg));
      message.error(errorMsg);
      throw error;
    }
  };
};